import React from "react";
import { Link } from "react-router-dom";
import { Mail, AlertTriangle } from "lucide-react";

const Label = ({ children }) => (
  <span className="w-20 shrink-0 text-[11px] uppercase tracking-wider font-semibold text-zinc-500">{children}</span>
);

export const GeenAdresHint = ({ locatie, isOversight, testid = "mail-geen-adres" }) => (
  <div data-testid={testid} className="flex items-start gap-2 rounded-md bg-amber-50 border border-amber-200 px-3 py-2 text-sm text-amber-800">
    <AlertTriangle className="h-4 w-4 mt-0.5 shrink-0" />
    <span>
      Geen e-mailadres bekend voor {locatie}. Vul het in bij{" "}
      <Link to={isOversight ? "/instellingen" : "/locatie-accounts"} className="font-semibold underline">
        {isOversight ? "Instellingen" : "Locatie-accounts"}
      </Link>.
    </span>
  </div>
);

export const MailConcept = React.forwardRef(({ mail, locatie, isOversight }, ref) => (
  <div className="bg-white rounded-[10px] border border-zinc-200 overflow-hidden" data-testid="mail-concept">
    <div className="flex items-center gap-2 px-4 py-3 border-b border-zinc-100 bg-zinc-50">
      <Mail className="h-4 w-4 text-zinc-500" />
      <span className="text-[11px] uppercase tracking-wider font-semibold text-zinc-500">E-mailconcept</span>
    </div>
    <div className="p-4 space-y-2.5">
      <div className="flex items-baseline gap-2 text-sm">
        <Label>Aan</Label>
        {mail.aan
          ? <span data-testid="mail-aan" className="text-zinc-900 break-all">{mail.aan.naam ? `${mail.aan.naam} <${mail.aan.email}>` : mail.aan.email}</span>
          : <span data-testid="mail-aan" className="text-amber-700 font-semibold">Geen e-mailadres</span>}
      </div>
      {!mail.aan && <GeenAdresHint locatie={locatie} isOversight={isOversight} />}
      <div className="flex items-baseline gap-2 text-sm">
        <Label>Onderwerp</Label>
        <span data-testid="mail-onderwerp" className="text-zinc-900 font-medium">{mail.onderwerp}</span>
      </div>
      <pre ref={ref} data-testid="mail-tekst" className="whitespace-pre-wrap break-words font-sans text-sm text-zinc-800 bg-zinc-50 border border-zinc-200 rounded-md p-3 max-h-[420px] overflow-y-auto">{mail.tekst}</pre>
      <p className="text-xs text-zinc-500">Opent in je eigen mailprogramma. Er wordt niets verstuurd zonder jou.</p>
    </div>
  </div>
));
MailConcept.displayName = "MailConcept";
